import { Container } from '@chakra-ui/react';
import React from 'react';
import { BiRightArrow, BiRightArrowAlt } from 'react-icons/bi';
import './Home.css'

const CardHome = ({ bg, photo, icon, title, text, src }) => {
    return (
        <Container maxW="container.lg" mt={10} className='rounded-lg'>
            <div className="  overflow-hidden">
                <div className="container m-auto px-0  space-y-1 text-gray-500 rounded-lg" >
                    
                    <div className="border divide-x divide-y rounded-xl overflow-hidden sm:grid-cols-2 lg:divide-y-0 lg:grid-cols-3 xl:grid-cols-4">
                        <div className="rounded-xl relative group bg-white dark:bg-lime-300 transition hover:z-[1] hover:shadow-2xl" >
                            <div className="p-7 space-y-1 relative block" >
                                <img src={photo} className="w-10 transform motion-safe:hover:scale-110 transition duration-300"  width="512" height="512" alt="burger illustration"/>

                                    <div className="space-y-2 mt-4 sm:pr-0 text-gray-900 hover:text-gray-900">
                                        <h5 className="text-xl text-gray-800 transition group-hover:text-yellow-600 font-mono font-bold">{title}</h5>
                                        <p className="text-sm  sm:block text-gray-600 font-mono">{text}</p>
                                    </div>
                                    <a href="#" className="flex justify-between items-center group-hover:text-yellow-600">
                                        <span className="text-sm">Read more</span>
                                        <span className="-translate-x-4 opacity-0 text-2xl transition duration-300 group-hover:opacity-100 group-hover:translate-x-0"><BiRightArrowAlt/></span>
                                    </a>
                            </div>
                        </div>


                    </div>
                </div>
            </div>


            </Container>
    );
};

export default CardHome;